import { IErrorResponseType } from "../../constants/commonTypes";
import { ProfileDetailsState } from "../reducers/profileDetailsReducer";

export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS"
export const GET_PROFILE_DETAILS_REQUEST = "GET_PROFILE_DETAILS_REQUEST"
export const GET_PROFILE_DETAILS_FAILURE = "GET_PROFILE_DETAILS_FAILURE"
export const GET_PROFILE_DETAILS_SUCCESS = "GET_PROFILE_DETAILS_SUCCESS"

export const AUM_MOBILE = "AUM_MOBILE"
export const AUM_MOBILE_REQUEST = "AUM_MOBILE_REQUEST"
export const AUM_MOBILE_FAILURE = "AUM_MOBILE_FAILURE"
export const AUM_MOBILE_SUCCESS = "AUM_MOBILE_SUCCESS"

export interface GetProfileDetailsAction {
  type: typeof GET_PROFILE_DETAILS;
}

export interface GetProfileDetailsRequestAction {
  type: typeof GET_PROFILE_DETAILS_REQUEST;
}

export interface GetProfileDetailsSuccessAction {
  type: typeof GET_PROFILE_DETAILS_SUCCESS;
  response: ProfileDetailsState;
}

export interface GetProfileDetailsFailureAction {
  type: typeof GET_PROFILE_DETAILS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export interface AumMobileAction {
  type: typeof AUM_MOBILE;
}

export interface AumMobileRequestAction {
  type: typeof AUM_MOBILE_REQUEST;
}

export interface AumMobileSuccessAction {
  type: typeof AUM_MOBILE_SUCCESS;
  response: string;
}

export interface AumMobileFailureAction {
  type: typeof AUM_MOBILE_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export type ProfileActions =
  | GetProfileDetailsAction
  | GetProfileDetailsRequestAction
  | GetProfileDetailsSuccessAction
  | GetProfileDetailsFailureAction

  | AumMobileAction
  | AumMobileRequestAction
  | AumMobileSuccessAction
  | AumMobileFailureAction;
